export const isIphoneModel = () => {
  if (typeof window === `undefined` || typeof navigator === `undefined`)
    return false;

  return /iPhone/i.test(navigator.userAgent);
};

export const isIosChrome = () => {
  return navigator.userAgent.match("CriOS");
};

export enum IphoneVersion {
  i_XS_11 = "i_XS_11",
  i_XS_11_MAX = "i_11_MAX",
  i_12_13 = "i_12_13",
  i_12_13_MAX = "i_12_13_MAX",
  i_12_13_PLUS = "i_12_13_PLUS",
  i_SE = "i_SE",
  i_12_13_mini = "i_12_13_mini",
}

export const getIphoneVersion = () => {
  if (!isIphoneModel()) return null;
  const height = window.outerHeight;
  if (window.outerHeight > 930) {
    return IphoneVersion.i_12_13_MAX;
  } else if (height > 900 && height < 930) {
    return IphoneVersion.i_12_13_PLUS;
  } else if (height > 875 && height < 900) {
    return IphoneVersion.i_XS_11_MAX;
  } else if (height > 825 && height < 875) {
    return IphoneVersion.i_12_13;
  } else if (height > 800 && height < 825) {
    return IphoneVersion.i_XS_11;
  } else if (height < 800) {
    return IphoneVersion.i_12_13_mini;
  }
};
